import HistoryMessage from '@/weon/models/HistoryMessage';
import i18n from '@/i18n';
import NewVoiceEvent from '@/weon/events/voice/NewVoiceEvent';
import NewChatEvent from '@/weon/events/chat/NewChatEvent';
import NewWhatsAppEvent from '@/weon/events/NewWhatsAppEvent';
import WhatsAppTransferEvent from '@/weon/events/WhatsAppTransferEvent';
import store from '@/store';
import JobService from '@/services/job-service';

export const getActiveJobsFromChannel = (channel, jobs) =>
  jobs.filter(
    (job) =>
      job.channel.toLowerCase() == channel.toLowerCase() && !job.disabled,
  );

export const formatMessagesJob = (historyMessages, job, agentId) => {
  return historyMessages.messages
    .map((value) => {
      const avatarPath = value.agent ? value.agent.avatar : null;
      let avatar = null;
      if (avatarPath) {
        const url =
          process.env.NODE_ENV == 'development'
            ? process.env.API_URL
            : window.CONFIG.weactionapi.url;
        avatar = url.slice(0, -1) + avatarPath;
      }

      let from = null;
      let to = null;
      if (job.channel.toLowerCase() == 'whatsapp') {
        if (value.from == job.routeWhatsapp.phonenumber) {
          from = value.bot.id != '' ? 'Bot' : value.agent.id;
        } else {
          from = job.contactIdentifier;
        }

        if (value.to == job.routeWhatsapp.phonenumber) {
          to = value.bot.id != '' ? 'Bot' : value.agent.id;
        } else {
          to = job.contactIdentifier;
        }
      } else {
        from =
          value.to != job.contactIdentifier ? job.contactIdentifier : agentId;
        to =
          value.to == job.contactIdentifier ? job.contactIdentifier : agentId;
      }

      const isForwarded = String(value?.forwarded).toLowerCase() === 'true';

      const isMessagefromDb = value?.strategy_campaign_id;

      const strategyCampaign = {};
      if (isMessagefromDb) {
        strategyCampaign.id = value?.strategy_campaign_id;
        strategyCampaign.name = value?.strategy_campaign_name;
        strategyCampaign.mailing_id = value?.mailing_id;
        strategyCampaign.mailing_name = value?.mailing_name;
        strategyCampaign.template_id = value?.preset_message_id;
      }

      return new HistoryMessage({
        from,
        to,
        message: value.content,
        event: value.event,
        type: value.type,
        time: value.created_at,
        protocol: value.protocol,
        agent_id: value.agent ? value.agent.id : null,
        agent_name: value.agent ? value.agent.name : null,
        avatar: value.agent ? avatar : null,
        status: value.status,
        mimetype: value.message_type,
        system_message: value.system_message == 'true',
        caption: value.message_caption,
        answeredMessage: value.message_caption_id,
        message_id: value.id,
        bot: value.hasOwnProperty('bot') ? value.bot.id != '' : false,
        id: value.api_message_id,
        header_agent_name: value.header_agent_name || '',
        header_show_agent_name:
          value.header_show_agent_name === 'true' || false,
        header_show_complete_agent_name:
          value.header_show_complete_agent_name === 'true' || false,
        forwarded: isForwarded,
        messageAnswered: value?.messageAnswered || {},
        strategyCampaign:
          value?.strategyCampaign ||
          value?.strategy_campaign ||
          strategyCampaign,
        event: value?.event,
      });
    })
    .filter((message) => message);
};

export const formatMessages = ({ messages, contactIdentifier, agentId }) =>
  messages.map((message) => {
    const isForwarded = String(message?.forwarded).toLowerCase() === 'true';

    const isMessagefromDb = message?.strategy_campaign_id;

    const strategyCampaign = {};
    if (isMessagefromDb) {
      strategyCampaign.id = message?.strategy_campaign_id;
      strategyCampaign.name = message?.strategy_campaign_name;
      strategyCampaign.mailing_id = message?.mailing_id;
      strategyCampaign.mailing_name = message?.mailing_name;
      strategyCampaign.template_id = message?.preset_message_id;
    }

    return new HistoryMessage({
      from: message.from == agentId ? agentId : contactIdentifier,
      to: message.to == agentId ? agentId : contactIdentifier,
      message: message.content,
      type: 'text',
      time: message.created_at,
      protocol: message.protocol,
      status: message.status,
      header_agent_name: message.header_agent_name || '',
      header_show_agent_name:
        message.header_show_agent_name === 'true' || false,
      header_show_complete_agent_name:
        message.header_show_complete_agent_name === 'true' || false,
      forwarded: isForwarded,
      messageAnswered: message?.messageAnswered || {},
      strategyCampaign:
        message?.strategyCampaign ||
        message?.strategy_campaign ||
        strategyCampaign,
      event: message?.event,
    });
  });

export const alreadyExistsInboxJob = (protocol, jobs) =>
  jobs.filter((job) => job.protocol == protocol).length > 0;

export const alreadyExistsJobByWhatsappIdentifier = (protocol, jobs) =>
  jobs.filter((job) => job.protocol == protocol).length > 0;

export const alreadyExistsMessageWhatsapp = (message_id, protocol, jobs) => {
  const jobFound = jobs.find((job) => job.protocol == protocol);

  if (jobFound === undefined) return false;

  return (
    jobFound.messages.filter(
      (msg) => Number(msg.message_id) == Number(message_id),
    ).length > 0
  );
};

export const getJobIdentifier = (job) => {
  const channel = job.channel.toLowerCase();
  const { metaType } = job || null;

  if (channel == 'whatsapp' && metaType == 'whatsapp')
    return job.contactIdentifier;
  if (channel == 'whatsapp' && metaType == 'instagram')
    return job.customFields?.contact_username;
  if (!metaType && channel == 'whatsapp') return job.contactIdentifier;
  if (channel == 'chat') return job.contactIdentifier;
  if (channel == 'voice') return job.phone;
  return '';
};

export const getJobIdentifierField = (job) => {
  const channel = job.channel.toLowerCase();
  const { metaType } = job || null;

  if (channel == 'voice') return 'contact_phone1';
  if (channel == 'whatsapp' && metaType == 'whatsapp')
    return 'whatsapp_identifier';
  if (channel == 'whatsapp' && metaType == 'instagram')
    return 'instagram_username';
  if (!metaType && channel == 'whatsapp') return 'whatsapp_identifier';
  if (channel == 'chat') return 'chat_identifier';
  return '';
};

export const verifyAgentNeedQualifyJob = (job) => {
  if (job.channel.toLowerCase() == 'voice') {
    return job.activeAttendance
      ? job.campaign?.use_qualification == 'Y'
      : job.queue?.use_qualification == 'Y';
  }
  return job.activeAttendance
    ? job.campaign?.qualify_group_id != null
    : job.queue?.qualify_group_id != null;
};

export const generateContactNotExists = (job, agentId) => {
  const identifier = (Math.random(Date.now()) + '-' + agentId).substr(2);
  const informationsContact = {
    contact_identifier: identifier,
    contact_fullname: i18n.t('notRegistered'),
  };

  const field = getJobIdentifierField(job);
  const value = getJobIdentifier(job);
  informationsContact[field] = value;
  return informationsContact;
};

/**
 * getAudioMessageDuration
 * Método responsável por obter a duração de uma mensagem de áudio
 * @param {string} url - URL do arquivo de áudio
 * @returns {Promise<string>} - Duração da mensagem de áudio formatada como "mm:ss"
 */
export const getAudioMessageDuration = (url) => {
  const audio = new Audio();
  audio.src = url;
  audio.preload = 'metadata';

  return new Promise((resolve, reject) => {
    function onLoadedMetadata() {
      resolve(formatAudioMessageDuration(audio.duration));
      cleanup();
    }
    function onError() {
      reject(new Error('Failed to load audio'));
      cleanup();
    }
    function cleanup() {
      audio.removeEventListener('loadedmetadata', onLoadedMetadata);
      audio.removeEventListener('error', onError);
      audio.pause();
      audio.src = '';
    }

    audio.addEventListener('loadedmetadata', onLoadedMetadata);
    audio.addEventListener('error', onError);

    audio.load();
  });
};

/**
 * formatAudioMessageDuration
 * Método responsável por formatar o tempo de uma mensagem de áudio
 * @param {number} duration - Tempo da mensagem de áudio em segundos
 * @returns {string} - Tempo formatado como "mm:ss"
 */
export const formatAudioMessageDuration = (duration) => {
  if (!duration || Number(duration) === 0 || Math.sign(duration) === -1)
    return '0:00';

  const minutes = Math.floor(duration / 60);
  const seconds = Math.floor(duration % 60);
  return `${minutes}:${seconds.toString().padStart(2, '0')}`;
};

export const getFileSize = async (url) => {
  try {
    const response = await fetch(url, { method: 'HEAD' });
    const size = response.headers.get('Content-Length');

    if (size !== null) {
      return formatFileSize(parseInt(size, 10));
    } else {
      throw new Error('No Content-Length header found');
    }
  } catch (error) {
    console.error('Error getting file size:', error);
    return null;
  }
};

/**
 * formatFileSize
 * Método responsável por formatar o tamanho de um arquivo
 * @param {number} size - Tamanho do arquivo em bytes
 * @returns {string} - Tamanho formatado como "KB", "MB", "GB", "TB"
 */
export const formatFileSize = (size) => {
  if (!size || Number(size) === 0 || Math.sign(size) === -1) return '';
  const units = ['B', 'KB', 'MB', 'GB', 'TB'];
  const index = Math.floor(Math.log(size) / Math.log(1024));
  return (size / 1024 ** index).toFixed(2) + ' ' + units[index];
};

/**
 * normalizeMessageContact
 * Método responsável por normalizar o contato de uma mensagem
 * @param {*} message
 * @returns
 */
export const normalizeMessageContact = (message) => {
  if (Array.isArray(message)) {
    return message;
  }

  return normalizeMessage(message);
};

export const normalizeMessage = (message) => {
  try {
    const messageParsed = JSON.parse(message);

    if (
      (typeof messageParsed === 'object' ||
        typeof messageParsed === 'string') &&
      messageParsed !== null
    ) {
      return messageParsed;
    }

    throw new Error('Mensagem não é um JSON válido');
  } catch (error) {
    return message;
  }
};

/**
 * validateJobList
 * Método responsável por validar a lista de joblist com a lista de jobs recebida por api
 * Caso algum job recebido pela api não estiver na lista de joblist, ele é adicionado na lista da aplicação através do evento disparado
 * Caso exista um job na lista de joblist que não está na lista de jobs recebida por api, ele é removido da lista da aplicação
 * @param {*} jobs
 * @returns {void}
 */
export const validateJobList = async () => {
  try {
    const agentId = store.state.attendance.Attendance.agentId;
    const jobs = await JobService.getJobsActive(agentId);

    if (!jobs) return;

    const eventMap = {
      NewVoiceEvent,
      NewChatEvent,
      NewWhatsAppEvent,
      WhatsAppTransferEvent,
    };

    const incomingProtocols = new Set();
    Object.values(jobs).forEach((jobArray) => {
      if (!Array.isArray(jobArray)) return;
      jobArray.forEach((job) => {
        if (job && job.protocol) incomingProtocols.add(job.protocol);
      });
    });

    const jobListStore = store.state.jobs.jobList;
    const currentJobsSnapshot = Array.isArray(jobListStore)
      ? [...jobListStore]
      : [];
    currentJobsSnapshot.forEach((job) => {
      if (job && job.protocol && !incomingProtocols.has(job.protocol)) {
        store.dispatch('jobs/removeJob', job.protocol);
      }
    });

    const jobList = new Set(jobListStore.map((job) => job.protocol));

    Object.entries(jobs).forEach(([key, jobArray]) => {
      if (!Array.isArray(jobArray)) return;

      jobArray.forEach((job) => {
        if (!job) return;
        if (key.includes('Closed')) {
          job.closedWithoutQualify = true;
        }

        if (!jobList.has(job.protocol)) {
          job.hasProtocolAttendance = true;
          const EventClass = eventMap[job.event];
          if (EventClass) {
            new EventClass(job);
          }
        }
      });
    });
  } catch (error) {
    console.error('Error validating job list:', error);
  }
};
